import src from "IMAGE";
export default { src, width: 2500, height: 669, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANUlEQVR42i3IIQoAIBAF0b2mwSJYBMWoYNDmZTzjd8KGN2FMUkHAwMFERMIzsn1mNCxUXPQPJGI3H4SJUKgAAAAASUVORK5CYII="};
